import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router';
import { LandingPage } from '@/routes/LandingPage';
import { NotFoundPage } from '@/routes/NotFoundPage';

// The room bundle (players, WebRTC, chat) loads only when a room is opened.
const RoomPage = lazy(() => import('@/routes/RoomPage').then((m) => ({ default: m.RoomPage })));

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  {
    path: '/r/:roomId',
    element: (
      <Suspense fallback={<div className="min-h-dvh bg-ink-950" />}>
        <RoomPage />
      </Suspense>
    ),
  },
  { path: '*', element: <NotFoundPage /> },
]);
